import type { AuditErrorLog, AuthLog } from "@/types/authLog";

import { api, unwrap } from "./axiosConfig";

export const authLogService = {
  /** The caller's own recent authentication events (self-service). */
  listMine(limit = 50): Promise<AuthLog[]> {
    return unwrap(api.get("/api/v1/me/auth-logs", { params: { limit } }));
  },

  /** All authentication events across users (platform admin). */
  listAll(params?: {
    event_type?: string;
    user_id?: number;
    success?: boolean;
    limit?: number;
    offset?: number;
  }): Promise<AuthLog[]> {
    return unwrap(api.get("/api/v1/admin/auth-logs", { params }));
  },

  /** Persisted 5xx server errors (platform admin). */
  listErrors(params?: { limit?: number; offset?: number }): Promise<AuditErrorLog[]> {
    return unwrap(api.get("/api/v1/admin/audit-error-logs", { params }));
  },
};
